<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div class="tag loading-tag" :class="['loading-tag', 'success-tag', 'error-tag', 'error-tag'][row.task_status]">{{
			['上传中', '上传成功', '上传失败', '部分失败'][row.task_status]
		}}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.tag {
	display: flex;
	align-items: center;
	&::before {
		content: '';
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 8px;
	}
	&.error-tag::before {
		background-color: #f03525;
	}
	&.loading-tag::before {
		background-color: #ff8b00;
	}
	&.success-tag::before {
		background-color: #00c840;
	}
}
</style>
